/// <reference path="../Entity/App.ts" />
/// <reference path="../Entity/HAApp.ts" />
/// <reference path="../Entity/HANavigationApp.ts" />
/// <reference path="./0Repository.ts" />
namespace HA.Core.Repository {
    import AppEntity = HA.Core.Entity.App;
    import HAApp = HA.Core.Entity.HAApp;
    import HTTPResponse = HA.Core.Route.HTTPResponse;
    import HANavigationApp = HA.Core.Entity.HANavigationApp;

    export class App extends Repository {

        /**
         *
         * @param data
         * @returns {HA.Core.Entity.HAApp|HA.Core.Entity.App}
         */
        public findNavigationById(data: Map<any, any>) {
            return this.findById(data, true);
        }

        public findById(data: Map<any, any>, isNavigation?: boolean): Promise<any> {

            if (this.isCached(data)) {
                return Promise.resolve(this.getFromCache(data));
            }

            if (data.size < 1) {
                return Promise.reject("no app id.");
            }

            const me = this;
            const reqData: string[] = [];
            data.forEach((v: any, n: any) => {
                reqData[n] = v;
            });

            return this.request(toMap({url: "/ha/app", data: reqData}))
                .then((response: Map<any, any>) => {
                    const elementData: Map<any, any> = toMap(response.get("app"));
                    let app: AppEntity | HAApp | HANavigationApp | HA.Core.Entity.FSApp = null;
                    if (elementData && response.get("success") === true) {
                        let aid = elementData.get("id");
                        if (!aid) {
                            aid = data.get("id");
                        } else {
                            data.set("id", aid);
                        }
                        if (data.has("_id") && !elementData.has("_id")) {
                            elementData.set("_id", data.get("_id"));
                        }
                        const appData = toMap({
                            id: aid,
                            services: me.getAppServices(),
                        }, elementData);

                        if (appData.has("navigationData")) {
                            return me.findById(toMap(appData.get("navigationData")), true).then(
                                (navApp: AppEntity) => {
                                    appData.set("navigation", navApp);
                                    app = new HAApp(appData);
                                    me.cache(data, app);
                                    return app;
                                });
                        } else {
                            if (data.has("_isModal") || appData.has("_isModal")) {
                                app = new HA.Core.Entity.FSApp(appData);
                            } else {
                                app = isNavigation ? new HANavigationApp(appData) : new AppEntity(appData);
                            }
                            me.cache(data, app);
                            return app;
                        }

                    } else {
                        return Promise.reject(response);
                    }

                }).catch((response: any) => {
                    return Promise.reject(response);
                });
        }

        public createApp(
            data: Map<any, any>,
            elementData: Map<any, any>,
            isNavigation?: boolean,
        ): AppEntity | HAApp | HANavigationApp | HA.Core.Entity.FSApp {

            let app: AppEntity | HAApp | HANavigationApp | HA.Core.Entity.FSApp;

            let aid = elementData.get("id");
            if (!aid) {
                aid = data.get("id");
            } else {
                data.set("id", aid);
            }
            if (data.has("_id") && !elementData.has("_id")) {
                elementData.set("_id", data.get("_id"));
            }
            const appData = toMap({
                id: aid,
                services: this.getAppServices(),
            }, elementData);

            if (data.has("_isModal") || appData.has("_isModal")) {
                app = new HA.Core.Entity.FSApp(appData);
            } else {
                app = isNavigation ? new HANavigationApp(appData) : new AppEntity(appData);
            }
            this.cache(data, app);
            return app;
        }

        /**
         *
         * @param id
         */
        public remove(id: string) {
            this.delFromCache(id);
        }

        protected getAppServices() {
            return {
                "ha.service.appManager": this.get("ha.service.appManager"),
                "ha.service.user": this.get("ha.service.user"),
                "ha.service.webpage": this.get("ha.service.webpage"),
            };
        }

        /**
         *
         * @param data
         * @returns {HTMLElement}
         */
        protected createElement(data: Map<any, any>) {
            const tempParent = document.createElement("div");
            tempParent.innerHTML = data.get("html");
            return tempParent.firstElementChild as HTMLElement;
        }

        protected queryDB(data: Map<any, any>) {
            const memoire: Map<string, any> = this.getMemoire();
            if (memoire && memoire.has(data.get("id"))) {
                return toMap(memoire.get(data.get("id")));
            } else {
                const appData = this.request(toMap({
                    cb: (response: HTTPResponse) => {
                        data.get("cb")(response.toMap());
                    },
                    data: {
                        id: data.get("id"),
                    },
                    url: "/ha/app",
                }));
            }
        }

        /**
         *
         * @returns {Map}
         */
        protected getMemoire() {
            return this.get("memoire");
        }

        protected initDB() {
            this.addToData("memoire", new Map());
        }
    }
}
